
export function showMobileMenu(header,menu, toggle) {
    header.classList.add("is-open-menu");
    menu.classList.add("is-open");
    toggle.classList.add("is-active");
    document.body.classList.add("is-open-menu");
}

export function hideMobileMenu(header,menu, toggle) {
    header.classList.remove("is-open-menu");
    menu.classList.remove("is-open");
    toggle.classList.remove("is-active");
    document.body.classList.remove("is-open-menu");
}